<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        تقارير الطلبة
        <v-spacer></v-spacer>
        <SearchStudentReport :trainingCenterId="trainingCenter" @clicked="onSearch" />
      </v-card-title>

      <v-row style="margin: 20px 10px">
        <v-col cols="4" v-for="(course, index) in splitCourses" :key="index">
          <v-card>
            <v-card-title class="warning-color" style="border-radius: 20px !important">
              <h5 style="padding: 0 3px">{{ course[0].courseName }}</h5>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <h3>عدد الطلبة : {{ course.length }}</h3>
                </v-col>
                <v-col cols="6">
                  <h3>
                    المبلغ :
                    {{
                      course
                        .reduce((n, { amount }) => n + amount, 0)
                        .toLocaleString("en-US", {
                          style: "currency",
                          currency: "IQD",
                        })
                    }}
                  </h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-data-table :headers="headers" :items="items" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.amount`]="{ item }">
          <h4 style="padding: 0 3px">
            {{
              item.amount.toLocaleString("en-US", {
                style: "currency",
                currency: "IQD",
              })
            }}
          </h4>
        </template>

        <!-- <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon @click="dialog = false">
                <DeleteStudentPayment :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
              </v-btn>
            </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import SearchStudentReport from "./report/SearchStudentReport.vue";
export default {
  components: {
    SearchStudentReport,
  },
  props: {
    trainingCenter: Number,
  },
  data: () => ({
    overlay: false,
    search: "",
    headers: [
      { text: "رقم الوصل", value: "idStudentPayment" },
      { text: "تاريخ الدفعة", value: "paymentDateFormat" },
      { text: "اسم الطالب", value: "studentName" },
      { text: "المبلغ", value: "amount" },
      { text: "اسم الكورس", value: "courseName" },
      { text: "اسم المستلم", value: "userName" },
      { text: "الملاحظات", value: "notes" },
    ],
    items: [],
    splitCourses: [],
  }),
  created() {},
  methods: {
    splitArrayCourse(courses) {
      const grouped = courses.reduce((acc, item) => {
        // If there's no array for this courseId yet, create one.
        if (!acc[item.courseId]) {
          acc[item.courseId] = [];
        }
        // Push the current object into its corresponding course array.
        acc[item.courseId].push(item);
        return acc;
      }, {});

      // Object.values() returns an array of all the grouped arrays.
      const result = Object.values(grouped);

      return result;
    },
    onSearch(value) {
      let self = this;
      self.items = value;
      self.splitCourses = self.splitArrayCourse(value);
    },
    allStudentPayments() {
      let self = this;
      self.$http
        .get(`${self.$store.state.apiUrl}/studentPaymentsForCourse?studentId=${self.studentId}&courseId=${self.courseId}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          self.studentPayments = res.data;
        });
    },
    searchPayment(value) {
      let self = this;
      console.log(value);
      self.studentPayments = value.data;
      self.studentId = value.studentId;
      self.courseId = value.courseId;
      self.showAddPayment = true;
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.resources.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.sectionName.toLowerCase().includes(v));
        });
      } else {
        return this.resources;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
